import moment from "moment";
export default {
  start: new Date(moment()),
  // end: new Date(moment().add(3, "month"))
  end: new Date(moment().add(1, "week")),
  type: "check_in"
};
